import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PeopleData from '../../services/people-service';
import './people.css';

export const ManagePerson = ({ accessToken }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [state, setState] = useState({
    person: {},
    accessToken,
    id
  });
  

  // Replace componentDidMount with useEffect
  useEffect(() => {
    // Create an async function inside useEffect
    const fetchData = async () => {
      try {
        // Get entries
        const person = await PeopleData.getPerson(id, accessToken);
        setState(prevState => ({
          ...prevState,
          person
        }));
      } catch ( error ) {

      }
    }

    if (id && accessToken) {
      fetchData();
    }

  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    
    const formData = {
      email: data.get('fromEmail'),
      givenName: data.get('givenName'),
      surname: data.get('surname')
    };

    try {
      await PeopleData.updatePerson(state.id, formData, state.accessToken);
      navigate('/people');
    } catch (error) {
      console.log("Fail - " + error);
      return;
    }
  };

  if ( !state ) {
    return <div>Loading...</div>;
  }

  const person = state.person;

  return (
    <div>
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <div className="form-group padding-10">
          <input
            type="hidden"
            id="id"
            name="id"
            value={person.id}
          />
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              id="givenName"
              placeholder="First Name"
              name="givenName"
              defaultValue={person.givenName}
            />
          </div>
          <div className="col-sm-6">
            <input
              type="text"
              className="form-control"
              id="surname"
              placeholder="Last name"
              name="surname"
              defaultValue={person.surname}
            />
          </div>
        </div>
        <div className="form-group padding-10">
          <div className="col-md-6">
            <input
              type="email"
              className="form-control"
              id="fromEmail"
              placeholder="Email"
              name="fromEmail"
              defaultValue={person.email}
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-md-12">
            <button
              type="submit"
              className="btn btn-primary btn-block contact"
            >
              Update Person
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};